import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#09090B] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-zinc-50 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück
        </Link>

        <h1 className="text-4xl font-black tracking-tighter text-zinc-50 mb-8" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Datenschutzerklärung
        </h1>

        <div className="space-y-8 text-zinc-300">
          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-medium text-zinc-50 mb-2">Allgemeine Hinweise</h3>
            <p className="text-zinc-400">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Anwendung nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">2. Verantwortliche Stelle</h2>
            <p>
              manage4yougroup UG (haftungsbeschränkt)<br />
              Am Kahlberg 8<br />
              91093 Heßdorf<br /><br />
              Telefon: 09135 7189445<br />
              E-Mail: sebastian.hotz@manage4yougroup.de
            </p>
            <p className="text-zinc-400 mt-4">
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">3. Datenerfassung in dieser Anwendung</h2>
            
            <h3 className="text-lg font-medium text-zinc-50 mb-2">Welche Daten werden erfasst?</h3>
            <p className="text-zinc-400 mb-4">
              In dieser Unfallanalyse-Anwendung werden folgende personenbezogene Daten erfasst:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-1 mb-4">
              <li>Benutzerdaten: Name, E-Mail-Adresse (für die Anmeldung)</li>
              <li>Unternehmenszugehörigkeit</li>
              <li>Unfallmeldungen: Abteilung, Datum, Art der Verletzung, Körperteil, Ursache, Beschreibung</li>
              <li>Hochgeladene Bilder zur Dokumentation von Unfällen</li>
            </ul>

            <h3 className="text-lg font-medium text-zinc-50 mb-2">Wofür werden die Daten genutzt?</h3>
            <p className="text-zinc-400 mb-4">
              Die Daten werden ausschließlich zur Erfassung, Dokumentation und Analyse von Arbeitsunfällen im Rahmen des betrieblichen Arbeitsschutzes verwendet. Dies dient der Erfüllung gesetzlicher Pflichten im Arbeitsschutz und der Prävention zukünftiger Unfälle.
            </p>

            <h3 className="text-lg font-medium text-zinc-50 mb-2">Rechtsgrundlage</h3>
            <p className="text-zinc-400">
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung), Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung im Arbeitsschutz) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Unfallprävention).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">4. Speicherung und Löschung</h2>
            <p className="text-zinc-400">
              Die erfassten Unfalldaten werden gemäß den gesetzlichen Aufbewahrungsfristen im Arbeitsschutz gespeichert. Personenbezogene Daten werden gelöscht, sobald der Zweck der Speicherung entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">5. Ihre Rechte</h2>
            <p className="text-zinc-400 mb-4">Sie haben jederzeit das Recht:</p>
            <ul className="list-disc list-inside text-zinc-400 space-y-1">
              <li>Auskunft über Ihre gespeicherten Daten zu erhalten (Art. 15 DSGVO)</li>
              <li>Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
              <li>Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
              <li>Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
              <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
              <li>Der Verarbeitung zu widersprechen (Art. 21 DSGVO)</li>
              <li>Sich bei einer Aufsichtsbehörde zu beschweren (Art. 77 DSGVO)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">6. Datensicherheit</h2>
            <p className="text-zinc-400">
              Diese Anwendung nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt. Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">7. Hosting</h2>
            <p className="text-zinc-400">
              Diese Anwendung wird extern gehostet. Die personenbezogenen Daten, die in dieser Anwendung erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen und sonstige Daten handeln, die über eine Anwendung generiert werden.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">8. E-Mail-Benachrichtigungen</h2>
            <p className="text-zinc-400">
              Bei Erstellung einer neuen Unfallmeldung wird automatisch eine E-Mail-Benachrichtigung an den Administrator gesendet. Diese E-Mails enthalten Informationen zur Unfallmeldung und werden über den Dienst Resend versendet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">9. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-zinc-400">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
            </p>
          </section>

          <section className="border-t border-zinc-800 pt-8">
            <p className="text-zinc-500 text-sm">
              Stand: März 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
